import { rails } from '@/Constants/rails';
import { racks } from '@/Constants/racks';
import { shelfBrackets } from '@/Constants/shelfBrackets';
import { rodHolder } from '@/Constants/rodHolder';
import { rods } from '@/Constants/rods';
import { trouserRack } from '@/Constants/trouserRack';
import { pullOutFrames } from '@/Constants/pullOutFrames';
import { baskets } from '@/Constants/baskets';
import { rackShift } from '@/Constants/common';
import { shelves } from '@/Constants/shelves';
import {
    boxDataProps,
    doorDataProps,
    moduleItem,
    roomData,
    wardrobeModule,
    windowDataProps,
    xy,
    xyz,
} from '@/Interfaces/common';
import { perforatedPanels } from '@/Constants/perforatedPanels';
import { rodCaps } from '@/Constants/rodCaps';




export const demoShelf1 = {
    uuid: crypto.randomUUID(),
    type: 'shelf',
    templates: {
        // basket: baskets[6],
        shelfBracketLeft: shelfBrackets[1],
        shelfBracketRight: shelfBrackets[1],
        // rodHolder: rodHolder,
        // rod: rods[1],
        trouserRack: trouserRack[0],
        // pullOutFrame: pullOutFrames[1],
    },
    height: 100,
    width: 600,
    depth: 400,
} as moduleItem;

export const demoShelf2 = {
    uuid: crypto.randomUUID(),
    type: 'shelf',
    templates: {
        shelfBracketLeft: shelfBrackets[1],
        shelfBracketRight: shelfBrackets[1],
        // shelf: shelves[3],
        // rodHolder: rodHolder,
        // rod: rods[1],
        // trouserRack: trouserRack[0],
        pullOutFrame: pullOutFrames[3],
        basket: baskets[6],
    },
    height: 100,
    width: 600,
    depth: 400,
} as moduleItem;

export const demoShelf3 = {
    uuid: crypto.randomUUID(),
    type: 'shelf',
    templates: {
        shelfBracketLeft: shelfBrackets[1],
        shelfBracketRight: shelfBrackets[1],
        shelf: shelves[4],
    },
    height: 0.1,
    width: 0.600,
    depth: 0.400,
} as moduleItem;

export const demoShelf4 = {
    uuid: crypto.randomUUID(),
    type: 'shelf',
    templates: {
        shelfBracketLeft: shelfBrackets[1],
        shelfBracketRight: shelfBrackets[1],
        shelf: shelves[4],
        rodHolder: rodHolder,
        rod: rods[1],
        rodCapLeft: rodCaps[0],
        rodCapRight: rodCaps[1],
    },
    height: 0.100,
    width: 0.600,
    depth: 0.400,
} as moduleItem;

export const demoShelf5 = {
    uuid: crypto.randomUUID(),
    type: 'shelf',
    templates: {
        shelfBracketLeft: shelfBrackets[0],
        shelfBracketRight: shelfBrackets[0],
        shelf: shelves[3],
    },
    height: 0.100,
    width: 0.600,
    depth: 0.400,
} as moduleItem;

export const demoShelf6 = {
    uuid: crypto.randomUUID(),
    type: 'shelf',
    templates: {
        shelfBracketLeft: shelfBrackets[2],
        shelfBracketRight: shelfBrackets[2],
        shelf: shelves[5],
    },
    height: 0.100,
    width: 0.600,
    depth: 0.400,
} as moduleItem;

export const demoShelf7 = {
    uuid: crypto.randomUUID(),
    type: 'shelf',
    templates: {
        shelfBracketLeft: shelfBrackets[1],
        shelfBracketRight: shelfBrackets[1],
        shelf: shelves[10],
    },
    height: 0.100,
    width: 0.600,
    depth: 0.400,
} as moduleItem;

export const demoShelf8 = {
    uuid: crypto.randomUUID(),
    type: 'shelf',
    templates: {
        basket: baskets[3],
        pullOutFrame: pullOutFrames[3],
        shelfBracketLeft: shelfBrackets[1],
        shelfBracketRight: shelfBrackets[1],
    },
    height: 0.100,
    width: 0.600,
    depth: 0.400,
} as moduleItem;

export const demoShelf9 = {
    uuid: crypto.randomUUID(),
    type: 'shelf',
    templates: {
        basket: baskets[4],
        pullOutFrame: pullOutFrames[3],
        shelfBracketLeft: shelfBrackets[1],
        shelfBracketRight: shelfBrackets[1],
    },
    height: 0.100,
    width: 0.600,
    depth: 0.400,
} as moduleItem;

export const demoShelf10 = {
    uuid: crypto.randomUUID(),
    type: 'shelf',
    templates: {
        basket: baskets[5],
        pullOutFrame: pullOutFrames[3],
        shelfBracketLeft: shelfBrackets[1],
        shelfBracketRight: shelfBrackets[1],
    },
    height: 0.100,
    width: 0.600,
    depth: 0.400,
} as moduleItem;

export const demoShelf11 = {
    uuid: crypto.randomUUID(),
    type: 'shelf',
    templates: {
        basket: baskets[8],
        pullOutFrame: pullOutFrames[3],
        shelfBracketLeft: shelfBrackets[1],
        shelfBracketRight: shelfBrackets[1],
    },
    height: 0.100,
    width: 0.600,
    depth: 0.400,
} as moduleItem;

export const demoPerforatedPanel = {
    uuid: crypto.randomUUID(),
    type: 'panel',
    templates: { panel: perforatedPanels[1] },
    height: 0.100,
    width: 0.600,
    depth: 0.400,
} as moduleItem;


export const wardrobeWindow = {
    uuid: crypto.randomUUID(),
    position: { x: 0, y: 1.5, z: 1 },
    rotation: { x: 0, y: 0, z: 0 },
};

export const wardrobeDoor = {
    uuid: crypto.randomUUID(),
    position: { x: 0, y: 1.5, z: 1 },
    rotation: { x: 0, y: 0, z: 0 },
};

export const demoShelves = [
    demoShelf3,
    demoShelf3,
    // demoShelf4,
    demoShelf2,
    demoPerforatedPanel,
    demoShelf1,
    demoShelf5,
    // demoShelf6,
    demoShelf7,
];

export const demoModule1 = {
    uuid: crypto.randomUUID(),
    templates: {
        rail: rails[2],
        rack: racks[3],
    },
    width: 0.600,
    height: 1.5,
    depth: 0.5,
    position: [ 1.0,2,0.02 ],
    railAlign: 'left', //left, right and center
    children: [
        demoShelf3,
        'prev',
        null,
        null,
        null,
        null,
        demoShelf4,
        'prev',
        // demoShelf4,
        // demoShelf2,
        // demoPerforatedPanel,
        // demoShelf1,
        // demoShelf5,
        // // demoShelf6,
        // demoShelf7,
    ],
    // children: {
    //     1: demoShelf3,
    //     2: 'prev',
    //     3: demoShelf3,
    //     4: 'prev',
    //     5: null,
    //     6: null,
    //     7: demoShelf2,
    //     8: 'prev',
    // },
    // units: [ 0,0,1,1,2,2,3,3,3,3,3,3,3,4,4, null, null, 5, 5, null,null,null,6,6 ],
    side: 'front',
} as wardrobeModule;

export const demoModule2 = {
    uuid: crypto.randomUUID(),
    templates: {
        // rail: rails[2],
        rack: racks[3],
    },
    children: [
        demoShelf3,
        'prev',
        demoShelf8,
        'prev',
        demoShelf9,
        'prev',
        demoShelf10,
    ],
    leftDocking: true,
    width: 0.600,
    height: 2.000,
    depth: 0.6,
    position: [ 1.6+2*rackShift,2,0.02 ],
    side: 'front',
} as wardrobeModule;

export const demoModule3 = {
    templates: {
        rail: rails[0],
        rack: racks[3],
    },
    children: [
        demoShelf6,
        'prev',
        demoShelf3,
        'prev',
        // demoShelf1,
        // demoShelf2,
        demoShelf4,
    ],
    leftDocking: false,
    width: 0.600,
    height: 2.000,
    depth: 0.6,
    position: [ 1, 2,0.02 ],
    side: 'back',
} as wardrobeModule;

export const demoModule4 = {
    templates: {
        rail: rails[0],
        rack: racks[2],
    },
    children: [
        demoShelf3,
        // demoShelf1,
        demoShelf2,
        demoShelf4,
    ],
    leftDocking: false,
    width: 0.600,
    height: 2.000,
    depth: 0.6,
    position: [ 1, 1.6,0.02 ],
    side: 'right',
} as wardrobeModule;

export const demoModules = [
    // demoModule1,
    // demoModule2,
    // demoModule3,
    // demoModule4,
];

export const demoKit = [
    demoModule1,
    demoModule2,
    // demoModule3,
    // demoModule4,
];
export const demoRoom = {
    height: 2.7,
    leftWallWidth: 3,
    rightWallWidth: 3,
    frontWallWidth: 3,
    backWallWidth: 0,
} as roomData;

export const demoDoors = [
    // {
    //     uuid: crypto.randomUUID(),
    //     width: 0.9,
    //     height: 2,
    //     position: [ 3.3, 0 ] as xy,
    //     side: 'front',
    //     // color: '#ff0000',
    //     color: '#ffffff',
    // } as doorData,
    // {
    //     width: 1,
    //     height: 1,
    //     position: [ 2, 0 ] as xy,
    //     side: 'left',
    //     color: '#e5e5e5',
    // } as doorData,
];

export const demoWindows = [
    // {
    //     uuid: crypto.randomUUID(),
    //     width: 0.5,
    //     height: 0.5,
    //     position: [ 1.0, 2 ] as xy,
    //     side: 'left',
    //     // color: '#ff0505',
    //     color: '#ffffff',
    //
    // } as windowData,
    // {
    //     uuid: crypto.randomUUID(),
    //     width: 0.7,
    //     height: 1.0,
    //     position: [ 1.7, 1.75 ] as xy,
    //     side: 'left',
    //     // color: '#ff0505',
    //     color: '#ffffff',
    //
    // } as windowData,
];

export const tempWindowDataTemplate = {
    uuid: 'temp',
    width: 0.5,
    height: 0.5,
    position: [ 0,0,0 ] as xyz,
    side: 'front',
    // color: '#ff0505',
    color: '#ffffff',
} as windowDataProps;

export const tempDoorDataTemplate = {
    uuid: 'temp',
    width: 0.9,
    height: 2.0,
    position: [ 0,0,0 ] as xyz,
    side: 'front',
    color: '#ffffff',
} as doorDataProps;

export const tempBoxDataTemplate = {
    uuid: 'temp',
    width: 0.6,
    height: 0.8,
    depth: 0.45,
    floorHeight: 0,
    position: [ 0,0,0 ] as xyz,
    side: 'front',
    color: '#ffffff',
} as boxDataProps;
